import { Route } from 'mk2/containers/Application/Application';
import * as React from 'react';

export interface RouterContextValue {
    routes: Route[];
}

const RouterContext = React.createContext<RouterContextValue>({
    routes: [],
});

export default RouterContext;
